import * as React from 'react';
import { Link } from 'react-router-dom';

import Button from '@/components/elements/Button/BaseButton';
import { ChargeType } from '@/modelTypes';

import { ResultText, Wrapper } from '../Success/style';

interface QuickChargeFailureProps {
  chargeType: ChargeType;
  handleClose: () => void;
}

const QuickChargeFailure: React.FC<QuickChargeFailureProps> = ({
  chargeType,
  handleClose,
}) => {
  return (
    <Wrapper>
      <ResultText>
        {chargeType === ChargeType.Credit && (
          <>
            ご利用のカードの3Dセキュア(本人認証サービス)認証に失敗したため、
            <br />
          </>
        )}
        toreta+ チャージが行えませんでした。
      </ResultText>
      <Link to="/news/info_3dsecure">
        <Button
          bgColor="primary"
          size={['s', 's', 'm', 'm']}
          width="240px"
          height="56px"
          fontWeight="bold"
          outline
          radius="l"
          onClick={() => handleClose()}
        >
          3Dセキュアについて
        </Button>
      </Link>
    </Wrapper>
  );
};

export default QuickChargeFailure;
